module.exports = __webpack_public_path__ + "registration-background-image.d9f534d999abe1e92b62b5267825bb74.jpg";